
/**
 *  @class
 *  @function CartDiscounts
 */


if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.discounts();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    discounts() {
      const button = this.querySelector('.cart-discounts--button');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove');

      if (!button) {
        return;
      }
      button.addEventListener('click', (event) => {
        button.classList.add('loading');

        this.updateDiscount();
        event.preventDefault();
        
      });
      this.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.cart-discounts--remove');

        if (!removeButton || !this.contains(removeButton)) return;

        event.preventDefault();
        event.stopPropagation();

        this.removeDiscount(removeButton);
      });
    }
    updateDiscount() {
      const discountCode = this.querySelector('.cart-discounts--input');
      const discountCodeValue = discountCode.value;
      const existingDiscounts = this.existingDiscounts();

      if (existingDiscounts.includes(discountCodeValue)){

        //添加自定义相同折扣码提示
        setTimeout(() => {
          document.querySelectorAll('.cart-discounts--error').forEach((el) => {
            el.removeAttribute('hidden');
            el.querySelector('.cart-discounts--error-text').textContent = "You have already applied the same discount code."
            });
        }, 300);

        const button = this.querySelector('.cart-discounts--button');
        button?.classList.remove('loading');

        return;
      }

      existingDiscounts.push(discountCodeValue);

      this.renderDiscounts(existingDiscounts, discountCodeValue);

    }
    
removeDiscount(removeButton) {
  const discountRow = removeButton.closest('.cart-discounts--row');

  if (!discountRow) return;

  const pill = discountRow.querySelector('.cart-discounts--name');

  if (!pill) return;

  const discountCode = pill.textContent.trim();
  const existingDiscounts = this.existingDiscounts();

  const index = existingDiscounts.findIndex(
    (code) => code.trim().toLowerCase() === discountCode.toLowerCase()
  );

  if (index === -1) return;

  existingDiscounts.splice(index, 1);

  removeButton.classList.add('loading');

  this.renderDiscounts(existingDiscounts);
}
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        discountCodes.push(pill.innerHTML);
      }

      return discountCodes;
    }
    renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      this.querySelector('.cart-discounts--error').setAttribute('hidden', '');
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          const wasDiscountOpen = !!this.closest('details[open]');
          const wasDrawerDiscountOpen = !!this.closest('.discount-toggle__content.active');

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          // Re-wire cart drawer toggles after innerHTML replacement
          const cartDrawer = document.getElementById('Cart-Drawer');
          if (cartDrawer && cartDrawer.notesToggle) {
            cartDrawer.notesToggle();
            cartDrawer.discountToggle();
            cartDrawer.updateFreeShipping();
          }

          // Restore discount form open state
          if (wasDiscountOpen) {
            document.querySelectorAll('.cart-discounts--title').forEach((el) => {
              el.closest('details').setAttribute('open', '');
            });
          }
          if (wasDrawerDiscountOpen) {
            const discountContent = document.querySelector('#mini-cart-discount');
            if (discountContent) discountContent.classList.add('active');
          }
          if (discountCodeValue && parsedState.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
          })) {
            setTimeout(() => {
              document.querySelectorAll('.cart-discounts--error').forEach((el) => {
                el.removeAttribute('hidden');
              });
            }, 300);
          }
        });
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
}
